import zeroPad from "./zeroPad"

export const SECOND_MS = 1000
export const MINUTE_MS = 60 * SECOND_MS
export const HOUR_MS = 60 * MINUTE_MS
export const DAY_MS = 24 * HOUR_MS

/*
 * Takes time in seconds and returns string in format hh:mm:ss or mm:ss
 *
 * @param {number} timeInSeconds
 */
export function formatTime(timeInSeconds: number): string {
  if (Number.isNaN(timeInSeconds) || timeInSeconds <= 0) {
    return "00:00"
  }

  const hours = Math.floor(timeInSeconds / 3600)
  const minutes = Math.floor((timeInSeconds % 3600) / 60)
  const seconds = Math.floor(timeInSeconds % 60)

  return `${hours > 0 ? `${zeroPad(hours)}:` : ""}${zeroPad(minutes)}:${zeroPad(seconds)}`
}
